import { Alert, Box, Button, Paper, Stack, Typography } from '@mui/material';

import { environment, isFeatureEnabled } from '@/config/environment';

import type { ReactNode } from 'react';

export function FeatureRoute({ feature, children }: { feature: string; children: ReactNode }) {
  if (isFeatureEnabled(feature)) return children;
  return (
    <Box sx={{ p: 2 }}>
      <Paper
        elevation={0}
        sx={{ maxWidth: 680, p: 3, border: '1px solid', borderColor: 'divider' }}
      >
        <Stack spacing={2}>
          <Typography variant="h1">Feature temporarily unavailable</Typography>
          <Alert severity="info">
            This React module is disabled for the current rollout. No data has been changed.
          </Alert>
          {environment.legacyAdminUrl && (
            <Button
              component="a"
              href={environment.legacyAdminUrl}
              variant="contained"
              sx={{ alignSelf: 'flex-start' }}
            >
              Continue in legacy admin
            </Button>
          )}
        </Stack>
      </Paper>
    </Box>
  );
}
